import { DEVICE_SIZES } from '../../../config/appConfig';
/**
 * Configuration settings for the industries carousel.
 *
 * @typedef {Object} CarouselSettings
 * @property {boolean} dots - Indicates whether dots/navigation indicators should be displayed.
 * @property {boolean} autoplay - Indicates whether the carousel should autoplay.
 * @property {boolean} infinite - Indicates whether the carousel should loop infinitely.
 * @property {number} speed - The speed of slide transition in milliseconds.
 * @property {number} slidesToShow - The number of slides to be displayed at once.
 * @property {number} slidesToScroll - The number of slides to be scrolled at a time.
 * @property {boolean} arrows - Indicates whether arrow navigation should be displayed.
 * @property {Object[]} responsive - Array of breakpoint settings for responsive behavior.
 *
 **/

export const settings = {
  dots: true,
  autoplay: true,
  infinite: true,
  speed: 1500,
  slidesToShow: 3,
  slidesToScroll: 3,
  arrows: false,
  responsive: [
    {
      breakpoint: DEVICE_SIZES.laptop,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: DEVICE_SIZES.tablet,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
};
